import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as config from "../../constants/config";
import * as handlers from "../../constants/handlers";
import * as itemTypes from "../../constants/itemTypes";
import * as methods from "../../constants/methods";
import * as orderStatus from "../../constants/orderStatus";
import * as rcc from "../../constants/rcc";
import * as resultCodes from "../../constants/resultCodes";
import * as settings from "../../constants/settings";
import * as navigationActions from "../../actions/navigationActions";
import * as settingsActions from "../../actions/settingsActions";
import * as formatHelper from "../../helpers/formatHelper";
import * as getterHelper from "../../helpers/getterHelper";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.INTERGAMMA_SET_ACTIVE_DATABASE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ACTIVE_DATABASE
                    },
                    method: handlers.INTERGAMMA_GET_ACTIVE_DATABASE,
                    tabId: tabId
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_SERVERS,
                        params: {
                            compatibleOnly: true,
                            activeOnly: true,
                            orderingOnly: true
                        }
                    },
                    method: handlers.GET_COMPATIBLE_SERVERS,
                    tabId: tabId
                }
            ];
        case handlers.INTERGAMMA_GET_ACTIVE_DATABASE:
            if (!responseHelper.isGetActiveDatabaseFormatValid(response)) {
                return [
                    {
                        type: actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE,
                        payload: {
                            database: modelHelper.mapDatabaseToObject(response.data)
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE,
                    payload: {
                        database: modelHelper.mapDatabaseToObject(response.data)
                    }
                },
                {
                    type: actionTypes.SET_ACTIVE_TAB_SCENE,
                    payload: {
                        tabId: tabId,
                        scene: componentTypes.COLOR_SCENE
                    }
                },
                {
                    type: actionTypes.SEARCH_PANEL_INIT,
                    payload: {
                        tabId: tabId,
                        type: componentTypes.MAIN_TAB,
                        local: false
                    }
                }
            ];
        case handlers.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ACTIVE_DATABASE
                    },
                    method: handlers.INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_BARCODE,
                    tabId: tabId
                }
            ];
        case handlers.INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_BARCODE:
            if (!responseHelper.isGetActiveDatabaseFormatValid(response)) {
                return [
                    {
                        type: actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE,
                        payload: {
                            database: modelHelper.mapDatabaseToObject(response.data)
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            let barcodeOrderRequests = [
                {
                    type: actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE,
                    payload: {
                        database: modelHelper.mapDatabaseToObject(response.data)
                    }
                },
                {
                    type: actionTypes.SET_ACTIVE_TAB_SCENE,
                    payload: {
                        tabId: tabId,
                        scene: componentTypes.SUMMARY_SCENE
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_SERVERS,
                        params: {
                            compatibleOnly: true,
                            activeOnly: true,
                            orderingOnly: true
                        }
                    },
                    method: handlers.GET_COMPATIBLE_SERVERS,
                    tabId: tabId
                }
            ];

            if (
                state.intergammaOrder.product === null ||
                state.intergammaOrder.base === null ||
                state.intergammaOrder.package === null
            ) {
                return barcodeOrderRequests;
            }

            barcodeOrderRequests.push({
                type: actionTypes.SERVER_REQUEST,
                payload: {
                    type: methods.METHOD_GET_PRODUCT_IMAGE,
                    params: {
                        productName: state.intergammaOrder.product.name,
                        baseName: state.intergammaOrder.base.name,
                        packageName: state.intergammaOrder.package.package.name,
                        online: state.settings.imagesSource === settings.SOURCE_ONLINE
                    }
                },
                method: handlers.INTERGAMMA_GET_PRODUCT_IMAGE,
                tabId: 0
            });

            return barcodeOrderRequests;
        case handlers.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ACTIVE_DATABASE
                    },
                    method: handlers.INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_CIF_BARCODE,
                    tabId: tabId,
                    next: getterHelper.getNextRequest(state.server.requests, response.sequence)
                }
            ];
        case handlers.INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_CIF_BARCODE:
            if (!responseHelper.isGetActiveDatabaseFormatValid(response)) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE,
                        payload: {
                            database: null
                        }
                    }
                ];
            }

            const resultActions = [
                {
                    type: actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE,
                    payload: {
                        database: modelHelper.mapDatabaseToObject(response.data)
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_SERVERS,
                        params: {
                            compatibleOnly: true,
                            activeOnly: true,
                            orderingOnly: true
                        }
                    },
                    method: handlers.GET_COMPATIBLE_SERVERS,
                    tabId: 0
                }
            ];

            const nextActions = getterHelper.getNextRequest(state.server.requests, response.sequence);

            if (nextActions !== null && Array.isArray(nextActions)) {
                return [...resultActions, ...nextActions];
            }

            return resultActions;
        case handlers.INTERGAMMA_SET_DATABASE_AND_OPEN_FANDECK_STEP:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ACTIVE_DATABASE
                    },
                    method: handlers.INTERGAMMA_GET_DATABASE_AND_OPEN_FANDECK_STEP,
                    tabId: tabId
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_SERVERS,
                        params: {
                            compatibleOnly: true,
                            activeOnly: true,
                            orderingOnly: true
                        }
                    },
                    method: handlers.GET_COMPATIBLE_SERVERS,
                    tabId: tabId
                }
            ];
        case handlers.INTERGAMMA_GET_DATABASE_AND_OPEN_FANDECK_STEP:
            if (!responseHelper.isGetActiveDatabaseFormatValid(response)) {
                return [
                    {
                        type: actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE,
                        payload: {
                            database: modelHelper.mapDatabaseToObject(response.data)
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE,
                    payload: {
                        database: modelHelper.mapDatabaseToObject(response.data)
                    }
                },
                {
                    type: actionTypes.SET_ACTIVE_TAB_SCENE,
                    payload: {
                        tabId: tabId,
                        scene: componentTypes.FANDECK_SCENE
                    }
                }
            ];
        case handlers.INTERGAMMA_RELOAD_COLORS:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.INTERGAMMA_SAVE_RELOADED_FORMULA_LIST,
                    payload: {
                        colorList: response.data
                    }
                }
            ];
        case handlers.INTERGAMMA_RELOAD_FANDECKS:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.INTERGAMMA_SAVE_RELOADED_FANDECK_LIST,
                    payload: {
                        fandeckList: response.data
                    }
                }
            ];
        case handlers.INTERGAMMA_GET_PRODUCTS_BY_PARAMS:
            if (!responseHelper.isGroupListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.INTERGAMMA_SAVE_PRODUCT_LIST,
                    payload: {
                        productList: response.data
                    }
                }
            ];
        case handlers.INTERGAMMA_GET_ALL_CUSTOMERS:
            if (!responseHelper.isGetAllCustomersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.INTERGAMMA_SAVE_CUSTOMER_LIST,
                    payload: {
                        customerList: response.data.customerList
                    }
                }
            ];
        case handlers.INTERGAMMA_MACHINE_ORDER_DETAIL:
            if (!responseHelper.isOrderDetailFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            response.data.order.shotsName = state.settings.shotsName;
            response.data.order.colorantPanelOrderBy = state.settings.colorantPanelOrderBy;

            return [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_PLAIN_ORDER_DETAIL,
                    payload: {
                        tabId: tabId,
                        order: response.data.order,
                        database: state.server.activeDatabase.name,
                        tmcData: response.data.order.tmcData,
                        infoData: response.data.order.infoData,
                        printData: response.data.order.printData,
                        validation: modelHelper.mapFormulaValidationErrorsToObject(
                            [],
                            rcc.RCC_VALIDATION_OK,
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        )
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_SET_ACTIVE_DATABASE,
                        params: {
                            name: response.data.order.brand,
                            autologin: true
                        }
                    },
                    method: handlers.INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE,
                    tabId: 0
                }
            ];
        case handlers.INTERGAMMA_MACHINE_ORDER_DETAIL_RELOAD:
            if (!responseHelper.isOrderDetailFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            response.data.order.shotsName = state.settings.shotsName;
            response.data.order.colorantPanelOrderBy = state.settings.colorantPanelOrderBy;

            return [
                {
                    type: actionTypes.TO_DISPENSE_SAVE_ORDER_DETAIL,
                    payload: {
                        tabId: tabId,
                        order: response.data.order,
                        printData: response.data.order.printData,
                        tmcData: response.data.order.tmcData,
                        infoData: response.data.order.infoData,
                        validation: modelHelper.mapFormulaValidationErrorsToObject(
                            [],
                            rcc.RCC_VALIDATION_OK,
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        )
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRODUCT_IMAGE,
                        params: {
                            productName: response.data.order.productName,
                            baseName: response.data.order.baseName,
                            packageName: response.data.order.packageName,
                            online: state.settings.imagesSource === settings.SOURCE_ONLINE
                        }
                    },
                    method: handlers.INTERGAMMA_MACHINE_GET_PRODUCT_IMAGE,
                    tabId: 0
                }
            ];
        case handlers.INTERGAMMA_MACHINE_SET_CANCELED_ORDER_STATUS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.INTERGAMMA_DELETE_ORDER_MODAL
                    }
                },
                {
                    type: actionTypes.TO_DISPENSE_RESET_ORDER
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_TO_DISPENSE_GET_ORDERS,
                        params: {
                            statusFilter: orderStatus.TO_DISPENSE_ORDER_STATUS_LIST,
                            orderBy: state.settings.intergammaMachineSortingOrders,
                            offset: 0,
                            rowCount: config.MAX_ORDERS_LIMIT
                        }
                    },
                    method: handlers.TO_DISPENSE_GET_ORDERS,
                    tabId: 0
                }
            ];
        case handlers.GET_CUSTOMER_BY_EMAIL:
            if (!responseHelper.isGetCustomerFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            let customerByMailActions = [
                {
                    type: actionTypes.SAVE_CUSTOMER_DETAIL,
                    payload: {
                        tabId: tabId,
                        customer: response.data
                    }
                }
            ];

            if (state.navigation.activeTabType === componentTypes.ORDERS_HISTORY_TAB) {
                customerByMailActions.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID,
                        params: {
                            customerId: response.data.id,
                            dateFrom: formatHelper.formatDateTimeForServer(state.intergammaOrder.from),
                            dateTo: formatHelper.formatDateTimeForServer(state.intergammaOrder.to)
                        }
                    },
                    method: handlers.INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID,
                    tabId: 0
                });
            }

            return customerByMailActions;
        case handlers.INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }
            return [
                {
                    type: actionTypes.MY_ORDERS_SAVE_DATA,
                    payload: {
                        myOrderList: response.data
                    }
                }
            ];
        case handlers.INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE:
            if (response.result === resultCodes.RESULT_INVALID_DATABASE_NAME) {
                return [
                    {
                        type: actionTypes.INTERGAMMA_MACHINE_UPDATE_DATABASE_ACCESS,
                        payload: {
                            databaseAvailability: componentTypes.ORDER_DATABASE_AVAILABLE_UNKNOWN_BRAND
                        }
                    }
                ];
            }

            if (response.result === resultCodes.RESULT_DATABASE_AUTOLOGIN_FAILED) {
                return [
                    {
                        type: actionTypes.INTERGAMMA_MACHINE_UPDATE_DATABASE_ACCESS,
                        payload: {
                            databaseAvailability: componentTypes.ORDER_DATABASE_AVAILABLE_LOGIN_FAILED
                        }
                    }
                ];
            }

            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ACTIVE_DATABASE
                    },
                    method: handlers.INTERGAMMA_MACHINE_GET_ACTIVE_DATABASE,
                    tabId: 0
                }
            ];
        case handlers.INTERGAMMA_MACHINE_GET_ACTIVE_DATABASE:
            if (!responseHelper.isGetActiveDatabaseFormatValid(response)) {
                return [
                    {
                        type: actionTypes.INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE,
                        payload: {
                            database: modelHelper.mapDatabaseToObject(response.data)
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE,
                    payload: {
                        database: modelHelper.mapDatabaseToObject(response.data)
                    }
                }
            ];
        case handlers.INTERGAMMA_GET_COLORANT_PACKAGE_BY_BARCODE:
            if (
                !responseHelper.isGetItemByBarcodeFormatValid(response) ||
                response.data.itemType !== itemTypes.COLORANT_PACKAGE
            ) {
                return [
                    {
                        type: actionTypes.MACHINE_SAVE_VALIDATION_COLORANT_PACKAGE,
                        payload: {
                            result: null
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.MACHINE_SAVE_VALIDATION_COLORANT_PACKAGE,
                    payload: {
                        result: response.data.item
                    }
                }
            ];
        case handlers.INTERGAMMA_GET_PRODUCT_IMAGE:
            if (!responseHelper.isImageFormatValid(response)) {
                if (response.result !== resultCodes.RESULT_OK) {
                    return [
                        messageHelper.getFlashMessage(response),
                        {
                            type: actionTypes.INTERGAMMA_SAVE_PACKAGE_IMAGE,
                            payload: {
                                imageId: -1
                            }
                        }
                    ];
                }

                return [
                    {
                        type: actionTypes.INTERGAMMA_SAVE_PACKAGE_IMAGE,
                        payload: {
                            imageId: -1
                        }
                    }
                ];
            }

            window.imageStore.addImage(response.data.imageId, {type: response.data.mimeType, img: response.data.data});

            return [
                {
                    type: actionTypes.INTERGAMMA_SAVE_PACKAGE_IMAGE,
                    payload: {
                        imageId: response.data.imageId
                    }
                }
            ];
        case handlers.STOCK_ADD_COLORANT_PACKAGES:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let newPayload1 = modelHelper.formatStockResponseData(response.data);

            let actions1 = [];
            if (
                state.settings.stockDatabaseFilter &&
                !newPayload1.databases.includes(state.settings.stockDatabaseFilter)
            ) {
                actions1 = [settingsActions.setStockDatabaseFilter(null)];
            }

            return actions1.concat([
                {
                    type: actionTypes.STOCK_SAVE_COLORANT_PACKAGES,
                    payload: newPayload1
                },
                messageHelper.getSuccessMessageAction("flashMessage.addedToStock"),
                navigationActions.closeModal(componentTypes.ADD_COLORANT_PACKAGES_TO_STOCK_MODAL)
            ]);
        case handlers.STOCK_ADD_COLORANT_PACKAGES_ORDER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let newPayload2 = modelHelper.formatStockResponseData(response.data);

            let actions2 = [];
            if (
                state.settings.stockDatabaseFilter &&
                !newPayload2.databases.includes(state.settings.stockDatabaseFilter)
            ) {
                actions2 = [settingsActions.setStockDatabaseFilter(null)];
            }

            return actions2.concat([
                {
                    type: actionTypes.STOCK_RESET_CART
                },
                {
                    type: actionTypes.STOCK_SAVE_COLORANT_PACKAGES,
                    payload: newPayload2
                },
                messageHelper.getSuccessMessageAction("flashMessage.orderCreated"),
                navigationActions.closeModal(componentTypes.COLORANT_PACKAGES_CONFIRM_ORDER_STOCK_MODAL),
                navigationActions.closeModal(componentTypes.MANUAL_ORDER_STOCK_MODAL)
            ]);
        case handlers.STOCK_GET_COLORANT_PACKAGES:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let newPayload3 = modelHelper.formatStockResponseData(response.data);

            let actions3 = [];
            if (
                state.settings.stockDatabaseFilter &&
                !newPayload3.databases.includes(state.settings.stockDatabaseFilter)
            ) {
                actions3 = [settingsActions.setStockDatabaseFilter(null)];
            }

            return actions3.concat([
                {
                    type: actionTypes.STOCK_SAVE_COLORANT_PACKAGES,
                    payload: newPayload3
                }
            ]);
        case handlers.STOCK_REMOVE_COLORANT_PACKAGE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let stockRemoveColorantPackageRequest = state.server.requests.find(
                (request) => request.id === response.sequence
            );

            let actions4 = [
                {
                    type: actionTypes.STOCK_CHECK_WARNING_STATUS,
                    payload: {
                        colorantPackages: modelHelper.mapStockItemsToObjects(response.data)
                    }
                }
            ];

            if (stockRemoveColorantPackageRequest?.next?.saveResult) {
                let newPayload4 = modelHelper.formatStockResponseData(response.data);

                if (
                    state.settings.stockDatabaseFilter &&
                    !newPayload4.databases.includes(state.settings.stockDatabaseFilter)
                ) {
                    actions4.push(settingsActions.setStockDatabaseFilter(null));
                }

                actions4.push({
                    type: actionTypes.STOCK_SAVE_COLORANT_PACKAGES,
                    payload: newPayload4
                });
            }

            if (stockRemoveColorantPackageRequest?.next?.showFlashMessage) {
                actions4.push(messageHelper.getSuccessMessageAction("flashMessage.colorantPackageRemovedStock"));
            }

            return actions4;
        case handlers.STOCK_SET_PREDICTION_FOR_COLORANT_PACKAGES:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.STOCK_CHECK_WARNING_STATUS,
                    payload: {
                        colorantPackages: modelHelper.mapStockItemsToObjects(response.data)
                    }
                }
            ];
        case handlers.GET_BARCODE:
            if (!responseHelper.isGetBarcodeValid(response)) {
                return [
                    {
                        type: actionTypes.RESET_BARCODE_DATA
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_BARCODE_DATA,
                    payload: {
                        data: response.data
                    }
                }
            ];
        case handlers.GET_BARCODE_AND_OPEN_MODAL:
            if (!responseHelper.isGetBarcodeValid(response)) {
                return [
                    messageHelper.getFlashMessage(response),
                    {
                        type: actionTypes.RESET_BARCODE_DATA
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_BARCODE_DATA,
                    payload: {
                        data: response.data
                    }
                },
                navigationActions.openModalWithParams(componentTypes.MODAL_NO_TAB, componentTypes.SHOW_BARCODE_MODAL, {
                    label: getterHelper.getNextRequest(state.server.requests, response.sequence)
                })
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
